export default "__VITE_ASSET__BKTgxCrX__"